/**
 * @param s {string} to be corrected.
 * @returns {string} corrected string.
 */
function spellingCorrection(s) {
    const C = {
        'Biege': 'Beige'
    }

    return C[s] ?? s;
}

/**
 * Generate a deterministic fallback color for unknown CSS color names.
 *
 * @param s {string}
 * @returns {string} HSL color string
 */
function stringToColor(s) {
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
        hash = s.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 60%, 70%)`;
}

/**
 * @param layer {{} | boolean}
 * @returns {boolean}
 */
function isAvailable(layer) {
    if (typeof layer === typeof true) {
        return layer;
    }

    let res = false;
    for (const c of Object.values(layer)) {
        res |= isAvailable(c);

        if (res) {
            break;
        }
    }

    return res;
}


/**
 * Note that the option selection process depends on the order of the selectors.
 * If you decide to change it in the future.
 * Ignore the no use warning. The function is used in `product-quick-add.liquid`
 *
 * @param id {string} product_form_id.
 * @param option_names {string} card_product.options_with_values.
 * @param variants_str {string} variants JSON string.
 * @param sold_out_txt {string} sold out text to be displayed on button.
 * @param add_to_cart_txt {string} add to cart text to be displayed on button.
 * @param cur_variant_str {string} current variant options JSON string.
 * @param price_str {string}
 * @param color_map_str {string} JSON string mapping color names to CSS values.
 */
function addCarousels(
    id,
    option_names,
    variants_str,
    sold_out_txt,
    add_to_cart_txt,
    cur_variant_str,
    price_str,
    color_map_str
) {
    /**
     * @typedef {{
     *     available: boolean,
     *     id: number,
     *     price: string,
     *     compare_at_price: string,
     *     options: string[]
     * }} Variant
     */
    /**
     * @type {Variant[]}
     */
    const variants = JSON.parse(variants_str);

    const prices = price_str.split('|');
    // Last element is empty
    prices.pop();

    const colorNameMap = (() => {
        const buildMapFromArray = (entries) => {
            const map = {};

            entries.forEach(entry => {
                if (typeof entry !== 'string') {
                    return;
                }

                const [rawName, ...rest] = entry.split('@');
                const rawValue = rest.join('@');
                const name = (rawName || '').trim();
                const value = (rawValue || '').trim();

                if (name && value) {
                    map[name] = value;
                }
            });

            return map;
        };

        try {
            const parsed = JSON.parse(color_map_str || '[]');

            if (Array.isArray(parsed)) {
                return buildMapFromArray(parsed);
            }

            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                return parsed;
            }

            if (typeof parsed === 'string') {
                return buildMapFromArray(parsed.split(/[,\r?\n]+/));
            }
        } catch (e) {}

        if (typeof color_map_str === 'string') {
            return buildMapFromArray(color_map_str.split(/[,\r?\n]+/));
        }

        return {};
    })();

    const getMappedColor = (name) => {
        if (!name) {
            return null;
        }
        const lowerName = name.toLowerCase();

        for (const [mapKey, mapValue] of Object.entries(colorNameMap)) {
            if (typeof mapValue !== 'string') {
                continue;
            }

            if ((mapKey || '').toLowerCase() === lowerName) {
                return mapValue;
            }
        }

        return null;
    };

    /**
     * @type {string[] | string}
     */
    let cur_variant_options = JSON.parse(cur_variant_str);

    /**
     * @type {Object<string, Variant>}
     */
    const option_var_map = {};

    /**
     * @type {Object<string, number>}
     */
    const variant_ind_map = {};

    /**
     * @type {{}}
     */
    const option_av_map = {};
    const money_field = document.getElementById(`price_${id}`);
    // const prev_money_field = document.getElementById(`compare_price_${id}`);
    const submit_btn = document.getElementById(`${id}-submit`);
    const btn_txt = document.getElementById(`submit-btn-text-${id}`);
    const SEP = '/';
    let prev_price = null;

    for (const [i, variant] of Object.entries(variants)) {
        const k = variant.options.join(SEP);
        option_var_map[k] = variant;
        variant_ind_map[k] = Number(i);
        const n = variant.options.length;
        const options = variant.options;

        if (n === 1) {
            option_av_map[options[0]] = variant.available;
            continue;
        }

        for (let i = 0; i < n; i++) {
            if (!(options[i] in option_av_map)) {
                option_av_map[options[i]] = {};
            }
            let layer = option_av_map[options[i]];
            let layer_parent = option_av_map;
            let last_j = i === n - 1 ? n - 2 : n - 1;

            for (let j = 0; j < n; j++) {
                if (i !== j) {
                    layer[options[j]] = {}
                    layer_parent = layer;
                    layer = layer[options[j]];
                }
            }

            layer_parent[options[last_j]] = variant.available;
        }
    }

    const options_list = option_names.split('/');
    const n = options_list.length;
    const id_field = document.getElementById(`selected-variant-id-${id}`);

    if (!id_field) {
        console.warn(`selected-variant-id-${id} NOT FOUND`);
        return;
    }

    const option_selectors = options_list.map(option => {
        return {
            e: document.getElementById(`ProductSelect-${id}-${option}`),
            t: option
        };
    });
    const disableStrikethrough = options_list.length > 1;

    /**
     * Performs the necessary update(s) on option variant selection
     *
     * @param ind {number} index at which the change took place.
     */
    const updateSelectedVariant = (ind) => {
        let v = "";
        id_field.value = "";
        submit_btn.disabled = true;
        btn_txt.textContent = sold_out_txt;
        if (disableStrikethrough) {
            const swatches = document.getElementsByClassName(`swatch-${id}`);
            for (const swatch of swatches) {
                swatch.classList.remove('unavailable', 'strikethrough', 'perm-strikethrough');
            }
        }

        option_selectors.forEach(({e, t}, i) => {
            v += `${i ? SEP : ''}${e.value}`;
        });

        const variant = option_var_map[v];
        money_field.innerText = prices[variant_ind_map[v]];

        if (prev_price && prev_price !== prices[variant_ind_map[v]]) {
            money_field.classList.add('blink-animation');
            setTimeout(() => {
                money_field.classList.remove('blink-animation');
            }, 500);
        }

        prev_price = prices[variant_ind_map[v]];

        if (variant?.available) {
            submit_btn.disabled = false;
            btn_txt.textContent = add_to_cart_txt;
            id_field.value = variant.id;
        }

        if (n === 1) {
            const t = option_selectors[0].t;

            for (let [option, available] of Object.entries(option_av_map)) {
                const swatch = document.getElementById(`option-variant-swatch-${id}-${t}-${option}`);

                if (swatch && !available && !disableStrikethrough) {
                    swatch.classList.add('unavailable', 'strikethrough');
                }
            }
        } else {
            const swatches = document.getElementsByClassName(`swatch-${id}`);
            for (const swatch of swatches) {
                if (!swatch.classList.contains(`swatch-ind-${ind}-${id}`)) {
                    swatch.classList.remove('unavailable', 'strikethrough');
                }
            }

            const t = option_selectors[ind].t;
            const e = option_selectors[ind].e;
            const option_value = e.value;
            const swatch = document.getElementById(`option-variant-swatch-${id}-${t}-${option_value}`);
            let layer = option_av_map[option_value];

            for (let i = 0; i < n; i++) {
                if (i !== ind) {
                    for (const [option_value_1, clayer] of Object.entries(layer)) {
                        const t_1 = option_selectors[i].t;
                        const swatch_1 = document.getElementById(`option-variant-swatch-${id}-${t_1}-${option_value_1}`);

                        if (swatch_1 && !isAvailable(clayer) && !disableStrikethrough) {
                            swatch_1.classList.add('unavailable', 'strikethrough');
                        }
                    }
                }
            }

            if (swatch && !isAvailable(option_av_map[option_value]) && !disableStrikethrough) {
                swatch.classList.add('unavailable', 'strikethrough');
            }
        }
    };

    if (cur_variant_options) {
        cur_variant_options = cur_variant_options[0];
    }

    if (!cur_variant_options || cur_variant_options.length === 0) {
        console.warn(`No current variant options ${id}`);
        return;
    }

    let actual_selector_size = 0;

    option_selectors.forEach(({e, t}, i) => {
        if (
            !e
            || document.getElementsByClassName(`swatch-${id}-${t}`).length !== 0
        ) {
            console.warn(`swatches already exist ${id}`);
            return;
        }

        const selectElement = e;
        const carouselContainer = document.getElementById(`carousel-inner-${id}-${t}`);
        const outerCarouselContainer = document.getElementById(`carousel-${id}-${t}`);
        const options = Array.from(selectElement.options);
        let addedActive = false;
        let cnt = 0;
        let curGrid = null;
        let curRow = null;
        const itemPerGrid = 3;

        if (options.length !== 1) {
            actual_selector_size++;
        }

        options.forEach((option, j) => {
            if (cnt % itemPerGrid === 0) {
                curGrid = document.createElement('div');
                curGrid.className = "container carousel-item";
                curRow = document.createElement('div');
                curRow.className = "row";
                curGrid.appendChild(curRow);
            }
            cnt++;

            const available = !option.disabled;
            const swatch = document.createElement('div');
            swatch.dataset.value = option.value;
            swatch.id = `option-variant-swatch-${id}-${t}-${option.value}`;

            if (t.toLowerCase() === "color") {
                swatch.innerHTML = "<span></span>";
                swatch.className = `swatch-ind-${i}-${id} swatch-${id} column swatch-${id}-${t} color-swatch ${available ? "" : (disableStrikethrough ? "" : "unavailable strikethrough")}`;

                const mappedColor = getMappedColor(option.value);
                const swatchColor = option.dataset.swatchColor;
                const swatchImage = option.dataset.swatchImage;
                const swatchFocalPoint = option.dataset.swatchFocalPoint;
                const canCheckSupport = typeof CSS !== 'undefined' && typeof CSS.supports === 'function';

                if (mappedColor) {
                    const lowerMapped = mappedColor.toLowerCase();
                    const isImage = lowerMapped.startsWith('http') || lowerMapped.startsWith('/') || lowerMapped.startsWith('data:') || lowerMapped.startsWith('url(');

                    if (isImage) {
                        swatch.style.backgroundImage = lowerMapped.startsWith('url(') ? mappedColor : `url(${mappedColor})`;
                        swatch.style.backgroundSize = 'cover';
                        swatch.style.backgroundPosition = swatchFocalPoint || 'center';
                    } else {
                        const isSupported = canCheckSupport ? CSS.supports('color', mappedColor) : true;
                        swatch.style.backgroundColor = isSupported ? mappedColor : stringToColor(mappedColor);
                    }
                } else if (swatchColor) {
                    swatch.style.backgroundColor = swatchColor;
                } else if (swatchImage) {
                    swatch.style.backgroundImage = `url(${swatchImage})`;
                    swatch.style.backgroundSize = 'cover';
                    swatch.style.backgroundPosition = swatchFocalPoint || 'center';
                } else {
                    const correctedColor = spellingCorrection(option.value);
                    const isSupportedColor = canCheckSupport ? CSS.supports('color', correctedColor) : true;
                    swatch.style.backgroundColor = isSupportedColor ? correctedColor : stringToColor(option.value);
                }
            } else {
                swatch.innerHTML = `<span class="swatch-text">${option.text.substring(0, 4)}</span>`;
                swatch.className = `swatch-ind-${i}-${id} swatch-${id} column swatch-${id}-${t} swatch ${available ? "" : (disableStrikethrough ? "" : "unavailable strikethrough")}`;

                const isLongText = option.text && option.text.length > 4;
                if (isLongText) {
                    swatch.classList.add('swatch-long-text');
                }
            }

            if (available) {
                if (!addedActive && cur_variant_options[i] === option.value) {
                    addedActive = true;
                    swatch.classList.add('active');
                    curGrid.classList.add('active');
                }

                swatch.addEventListener('click', function() {
                    document.querySelectorAll(`.swatch-${id}-${t}`).forEach(s => s.classList.remove('active'));
                    swatch.classList.add('active');
                    selectElement.value = option.value;
                    updateSelectedVariant(i);
                });
            }

            if (options.length !== 1) {
                curRow.appendChild(swatch);
                curGrid.appendChild(curRow);
                if (cnt % itemPerGrid === 0 || j === options.length - 1) {
                    carouselContainer.appendChild(curGrid);
                }
            }
        });

        if (cnt <= itemPerGrid) {
            outerCarouselContainer.classList.add('no-btn');
            const controlBtns = document.querySelectorAll(`.carousel-control-btn-${id}-${t}`);
            controlBtns.forEach(btn => btn.style.visibility = 'hidden');
        }
    });

    if (actual_selector_size > 1) {
        const swatches = document.getElementsByClassName(`swatch-${id}`);
        for (const swatch of swatches) {
            if (!isAvailable(option_av_map[swatch.dataset.value]) && !disableStrikethrough) {
                swatch.classList.add('unavailable', 'strikethrough');
            }
        }
    }

    if (disableStrikethrough) {
        const swatches = document.getElementsByClassName(`swatch-${id}`);
        for (const swatch of swatches) {
            swatch.classList.remove('unavailable', 'strikethrough', 'perm-strikethrough');
        }
    }

    for (let i = 0; i < n; i++) {
        updateSelectedVariant(i);
    }
}
